import { RootState } from './RootState';

export type { RootState };

export interface MenuInfo {
  key: React.Key;
  keyPath: React.Key[];
  item: React.ReactInstance;
  domEvent: React.MouseEvent<HTMLElement>;
}

export interface IRouteWithEnvIdParams {
  envId: string;
}
export enum localStorageEnum {
  token = 'token',
  envId = 'envId',
  selectedTheme = 'selectedTheme',
  mapLayer = 'mapLayer',
  seasonId = 'seasonId',
}

export enum testIdEnum {
  taskStatusCircle = 'taskStatusCircle',
  taskLateWaningCircle = 'taskLateWaningCircle',
  taskPlannedCompletionColumn = 'taskPlannedCompletionColumn',
}

export enum ErrorCodeEnum {
  userAlreadyExists = 'USER_ALREADY_EXISTS',
  hikoEnvNotFound = 'HIIKO_ENVIRONMENT_NOT_FOUND',
  fieldIntersection = 'FIELD_INTERSECTION',
}

export interface IOption<T = number> {
  label: string;
  value: T;
}

export interface IPaginated<T> {
  content: T[];
  pageable: {
    sort: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  first: true;
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export interface ITableSort {
  order?: 'ascend' | 'descend';
  field?: string | string[];
}
